import { DuidBCAan, DuidBCAan2, TelBCs } from "../../../../content/fysica/grootheden_eenheden/beduidende_cijfers/exercises/beduidendeCijfers";
import * as React from 'react';
export default {
  DuidBCAan,
  DuidBCAan2,
  TelBCs,
  React
};